import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import Home from './screens/Home';
import Vacation from './screens/Vacation';
import Calendar from './screens/Calendar';
import TimeCards from './screens/TimeCards';
import Users from './screens/Users';
import Holidays from './screens/Holidays';
import Login from './screens/Login';
import Vacations from './screens/Vacations';
import Projects from './screens/Projects';
import MyReports from './screens/MyReports';
import Reports from './screens/Reports';



import { HashRouter, Switch } from 'react-router-dom';

import configureStore from './store/configureStore';
import { Provider } from 'react-redux';

import Route from './AuthRoute';

const store = configureStore();

ReactDOM.render(
    <Provider store={store}>
      <HashRouter>
        <div>
          <Switch>
            <Route component={Home} exact path='/'/>
            <Route component={Vacation} exact path='/vacation'/>
            <Route component={Calendar} exact path='/calendar'/>
            <Route component={TimeCards} exact path='/timeCards'/>
            <Route component={Vacations} path='/vacations'/>
            <Route component={Users} exact path='/users'/>
            <Route component={Holidays} exact path='/holidays'/>
            <Route component={Projects} exact path='/projects'/>
            <Route component={MyReports} exact path='/myreports'/>
            <Route component={Reports} exact path='/reports'/>
            <Route component={Login} path='/login'/>
          </Switch>
        </div>
      </HashRouter>
    </Provider>, document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.js